
// NOTE: Test merchant
export default {
  code: 'BUS_NZ_ERERER'
}